<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Solicitação de certificado digital</div>
      <b-card class="shadow-sm mb-2 bg-white rounded schedule-success">
        <wizard :steps="wizardSteps" :activeIndex="wizardActiveIndex"></wizard>
        <hr />
        <b-alert v-model="showErro" variant="danger">{{
          mensagemErro
        }}</b-alert>

        <div v-if="loadingSummary" class="text-center" style="margin-top: 4rem">
          <b-spinner label="Loading..."></b-spinner>
        </div>

        <div v-if="!loadingSummary">
          <h5 style="color: var(--main-color)">Confirme os dados:</h5>

          <div
            v-if="ar.pf"
            style="margin: 1rem 0 1.2rem 0; line-height: 1.6rem"
          >
            <b>Certificado:</b>
            {{ orderSummary.certificateName }}
            <br />
            <template v-if="ar.institucional">
              <b>Órgão:</b>
              {{ orderSummary.orgaoContratanteName }}
              <br />
            </template>
            <b>Nome:</b>
            {{ orderSummary.customerName }}
            <br />
            <b>CPF:</b>
            {{ orderSummary.cpf }}
            <br />
            <b>Nascimento:</b>
            {{ orderSummary.birthDate }}
            <br />
            <template v-if="orderSummary.nomeSocial != null">
              <b>Nome Social:</b>
              {{ orderSummary.nomeSocial }}
              <br />
            </template>
            <div v-if="orderSummary.nis != null">
              <b>NIS:</b>
              {{ orderSummary.nis }}
              <br />
            </div>
            <div v-if="orderSummary.cei != null">
              <b>CAEPF(12 primeiros dígitos):</b>
              {{ orderSummary.cei }}
              <br />
            </div>
            <b>E-mail:</b>
            {{ orderSummary.email }}
            <br />
            <b>Telefone:</b>
            {{ orderSummary.phone }}
          </div>

          <div
            v-if="ar.equipamento || ar.pj"
            style="margin: 1rem 0 1.2rem 0; line-height: 1.6rem"
          >
            <b style="color: var(--main-color)">Certificado</b>
            <br />
            <b>Tipo:</b>
            {{ orderSummary.certificateName }}
            <br />
            <template v-if="ar.institucional">
              <b>Órgão:</b>
              {{ orderSummary.orgaoContratanteName }}
              <br />
            </template>
            <div v-if="ar.equipamento">
              <b>Domínio:</b>
              {{ orderSummary.sslCommonName }}
              <br />
            </div>
            <div style="margin-top: 1rem">
              <b style="color: var(--main-color)">Empresa</b>
              <br />
            </div>
            <b>CNPJ:</b>
            {{ orderSummary.customerCnpj }}
            <br />
            <b>Nome no CNPJ:</b>
            {{ orderSummary.customerCompanyName }}
            <br />
            <b>Município:</b>
            {{ orderSummary.customerCompanyLocality }}
            <br />
            <b>UF:</b>
            {{ orderSummary.customerCompanyState }}
            <div v-if="orderSummary.representanteLegal">
              <div style="margin-top: 1rem">
                <b style="color: var(--main-color)">Representante Legal</b>
                <br />
              </div>
              <b>Nome:</b>
              {{ orderSummary.representanteLegalName }}
              <br />
              <b>CPF:</b>
              {{ orderSummary.representanteLegalCpf }}
              <br />
              <b>Nascimento:</b>
              {{ orderSummary.representanteLegalBirthDate }}
              <br />
              <div v-if="orderSummary.nis != null">
                <b>NIS:</b>
                {{ orderSummary.nis }}
                <br />
              </div>
              <div v-if="orderSummary.cei != null">
                <b>CAEPF(12 primeiros dígitos):</b>
                {{ orderSummary.cei }}
              </div>
              <div style="margin-top: 1rem">
                <b style="color: var(--main-color)">Responsável pelo Uso</b>
                <br />
              </div>
              <b>Nome:</b>
              {{ orderSummary.customerName }}
              <br />
              <b>CPF:</b>
              {{ orderSummary.cpf }}
              <br />
              <b>Nascimento:</b>
              {{ orderSummary.birthDate }}
              <br />
              <template v-if="orderSummary.nomeSocial != null">
                <b>Nome Social:</b>
                {{ orderSummary.nomeSocial }}
                 <br />
              </template>
              <b>E-mail:</b>
              {{ orderSummary.email }}
              <br />
              <b>Telefone:</b>
              {{ orderSummary.phone }}
            </div>
            <div v-else style="margin-top: 1rem">
              <b style="color: var(--main-color)">Representante Legal</b>
              <br />
              <b>Nome:</b>
              {{ orderSummary.customerName }}
              <br />
              <b>CPF:</b>
              {{ orderSummary.cpf }}
              <br />
              <b>Nascimento:</b>
              {{ orderSummary.birthDate }}
              <br />
              <template v-if="orderSummary.nomeSocial != null">
                <b>Nome Social:</b>
                {{ orderSummary.nomeSocial }}
                 <br />
              </template>
              <div v-if="orderSummary.nis != null">
                <b>NIS:</b>
                {{ orderSummary.nis }}
                <br />
              </div>
              <div v-if="orderSummary.cei != null">
                <b>CAEPF(12 primeiros dígitos):</b>
                {{ orderSummary.cei }}
                <br />
              </div>
              <b>E-mail:</b>
              {{ orderSummary.email }}
              <br />
              <b>Telefone:</b>
              {{ orderSummary.phone }}
            </div>
          </div>
          <hr />
          <div class="botoes-wizard">
            <b-form @submit.stop.prevent="enviar">
              <b-button
                onclick="history.back(-1)"
                variant="secondary"
                v-if="!loading"
                class="btn-sd mr-4"
                >Cancelar
              </b-button>
                <b-button
                  variant="primary"
                  type="submit"
                  class="btn-sd"
                  style="float: right"
                  v-if="!loading"
                  >Confirmar</b-button
                >
              <b-button
                variant="primary"
                disabled
                v-if="loading"
                class="btn-sd"
                style="float: right"
              >
                <b-spinner small type="grow"></b-spinner>&nbsp;Confirmando...
              </b-button>
            </b-form>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";
import wizard from "./components/Wizard.vue";

export default {
  components: {
    cabecalho,
    wizard,
  },
  data() {
    return {
      mensagemErro: null,
      showErro: false,
      loading: false,
      loadingSummary: false,
      orderSummary: {},
    };
  },
  computed: {
    ar: function () {
      var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        return JSON.parse(arAndCertificate);
      }
      return null;
    },
    wizardSteps: function () {
      return ["Identificação", "Contato", "Informações Adicionais", "Confirmação"]
    },
    wizardActiveIndex: function () {
      return 3;
    },
  },
  created() {
    this.getOrderSummary();
  },
  methods: {
    enviar: function () {
      this.loading = true;
      this.showErro = false;
      this.$http
        .post(
          this.$serviceUrl + "/order/confirmation",
          {},
          {
            headers: {
              Authorization: sessionStorage.getItem("token"),
            },
          }
        )
        .then(
          (resp) => {
            sessionStorage.setItem("orderSuccess", JSON.stringify(resp.body));
            if(resp.body.jwt != null){
              sessionStorage.setItem("token", resp.body.jwt);
            }
            this.$router.replace("/order/step/success");
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Não encontrado";
            } else if(resp.status == 403 && !resp.body.message) {
              this.mensagemErro = "Situação inválida para a operação.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    getOrderSummary: function () {
      this.showErro = false;
      this.loadingSummary = true;
      this.$http
        .get(this.$serviceUrl + "/order/summary", {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        })
        .then(
          (resp) => {
            this.orderSummary = resp.body;
            this.loadingSummary = false;
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Não encontrado";
            } else if(resp.status == 403 && !resp.body.message) {
              this.mensagemErro = "Situação inválida para a operação.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loadingSummary = false;
          }
        );
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/OrderConfirmation.vue